import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 32 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M31.1199 0.799805H0.965576V30.9541H31.1199V0.799805Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
